import * as React from 'react';
import { FavoriteButtonsGroup } from '../../components/FavoriteButtonsGroup';
import { showFavoritesFoldersList } from '../../actions';
import { useDispatch } from 'react-redux';
import { FolderButton } from '../../components/FolderButton';
import { IconPlus16, Button } from '@cian/ui-kit';
import { jsx as _jsx } from "react/jsx-runtime";
export function FavoriteButtonsGroupContainer(_ref) {
  var offerId = _ref.offerId,
    isFavorite = _ref.isFavorite,
    foldersCount = _ref.foldersCount,
    onClickFavorite = _ref.onClickFavorite;
  var dispatch = useDispatch();
  var offerIds = [offerId];
  var handleClickFolder = function handleClickFolder() {
    dispatch(showFavoritesFoldersList({
      offerIds: offerIds
    }));
  };
  var folderButton = foldersCount && foldersCount > 0 ? /*#__PURE__*/_jsx(FolderButton, {
    foldersCount: foldersCount,
    onClick: handleClickFolder
  }) : /*#__PURE__*/_jsx(Button, {
    onClick: handleClickFolder,
    size: "XS",
    beforeIcon: /*#__PURE__*/_jsx(IconPlus16, {}),
    theme: "fill_secondary",
    children: "\u0421\u043E\u0445\u0440. \u0432 \u043F\u043E\u0434\u0431\u043E\u0440\u043A\u0443"
  });
  return /*#__PURE__*/_jsx(FavoriteButtonsGroup, {
    isFavorite: isFavorite,
    folderButton: folderButton,
    onClickFavorite: onClickFavorite
  });
}